
<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("dailysalesreport") }}</div>
      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getDailyReportFromDate"
                  @click.prevent="
                    onDailyReportDateHandler({ event: null, name: 'fromDate' })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  :value="getDailyReportFromDate"
                  typeable
                  @selected="
                    onDailyReportDateHandler({
                      event: $event,
                      name: 'fromDate',
                    })
                  "
                  v-validate="'required'"
                ></Datepicker>
                <label :class="getDailyReportFromDate ? 'active' : ''"
                  >{{ $t("transactions") }} {{ $t("date") }}</label
                >
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getDailyReportToDate"
                  v-on:click="
                    onDailyReportDateHandler({ event: null, name: 'toDate' })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onDailyReportDateHandler({ event: $event, name: 'toDate' })
                  "
                  :value="getDailyReportToDate"
                  ref="programaticOpen"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="getDailyReportToDate ? 'active' : ''"
                  >End Date</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  getDailyReportSelectedCinema &&
                  getDailyReportSelectedCinema.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :text="getDailyReportSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
                :disabled="isRoleID"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    onDailyReportDropdownHandler({
                      event: $event,
                      name: 'Cinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex,
                    });
                    searchCinema = '';
                    onSearchCinema();
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  getDailyReportSelectedPosUser &&
                  getDailyReportSelectedPosUser.length > 0
                    ? 'shift-up'
                    : 'd-none'
                "
                >{{ $t("select") }} {{ $tc("user", 1) }}</label
              >
              <!-- <b-dropdown
                :text="getDailyReportSelectedPosUser"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getPosUsersList"
                  :key="dropdownIndex"
                  @click="onDailyReportDropdownHandler({ event: $event, name:'PosUser',selectedItem: dropdownItem, index:dropdownIndex })"
                >
                  <span>{{ dropdownItem.user_id ? `${dropdownItem.first_name} ${dropdownItem.middle_name } ${ dropdownItem.last_name }`: 'All' }}</span>
                </b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :options="getPosUsersList"
                :searchable="true"
                :placeholder="
                  getDailyReportSelectedPosUser &&
                  getDailyReportSelectedPosUser.length > 0
                    ? getDailyReportSelectedPosUser
                    : 'Select User'
                "
                :customLabel="setLabel"
                track-by="user_id"
                @select="
                  onDailyReportDropdownHandler({
                    event: $event,
                    name: 'PosUser',
                    selectedItem: $event,
                  })
                "
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  getDailyReportSelectedPaymentMode &&
                  getDailyReportSelectedPaymentMode.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $t("paymentmode") }}</label
              >
              <b-dropdown
                :text="getDailyReportSelectedPaymentMode"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in getPaymentTypesList"
                  :key="dropdownIndex"
                  @click="
                    onDailyReportDropdownHandler({
                      event: $event,
                      name: 'PaymentMode',
                      selectedItem: dropdownItem,
                      index: dropdownIndex,
                    })
                  "
                  >{{ dropdownItem.pm_payment_mode }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click="onFetchReport()">
              {{ $t("fetch") }} {{ $t("report") }}
            </button>
          </div>

          <div
            v-if="
              getDailyReportList.length > 0 ||
              getSaleCashCard.length > 0 ||
              getTopUpCashCard.length > 0 ||
              getDailyConcessionReportList.length > 0 ||
              getConcessionDailyReportData.length > 0 ||
              FlatMerchandiseTransactions.length > 0
            "
            class="col-lg-6 col-xl-6 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div>{{ $t("download") }} as:</div>
            <a
              v-if="getDailyPDFFileName"
              :href="BASE_URL + getDailyPDFFileName"
              target="_blank"
              download
              title="Download as PDF"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              v-if="getDailyExcelFileName"
              :href="BASE_URL + getDailyExcelFileName"
              target="_blank"
              title="Download as Excel"
              download
            >
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </a>
          </div>

          <div class="col-md-3 align-self-center">
            <!-- <b-dropdown id="listview" variant="outline-blue-lg">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{selectedvalue}}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
            >{{list.name}}</b-dropdown-item>
            </b-dropdown>-->
          </div>
        </div>
      </div>

      <div class="swc-report">
        <table class="swc-report-table" border="1" style="table-layout: auto">
          <thead>
            <tr>
              <th class="bg-lightgrey text-left">{{ $t("outlet") }}</th>
              <th class="bg-lightgrey">{{ $tc("user", 2) }}</th>
              <th class="bg-lightgrey">{{ $t("suboutlet") }}</th>
              <th class="bg-lightgrey">
                {{ $tc("payment", 1) }} {{ $tc("type", 1) }} /
                {{ $t("partner") }}
              </th>
              <th class="bg-lightgrey">
                {{ $t("offer") }} / {{ $t("voucher") }}
              </th>
              <th class="bg-lightgrey">
                {{ $t("number") }} Of {{ $tc("ticket", 1) }}
              </th>
              <th class="bg-lightgrey">
                {{ $t("Payment Mode Amount") }}
              </th>
              <th class="bg-lightgrey">
                {{ $t("Cash Card Amount") }}
              </th>
              <th class="bg-lightgrey">
                {{ $t("gross") }} {{ $tc("revenue", 1) }}
              </th>
              <th class="bg-lightgrey">{{ $t("net") }} {{ $t("revenue") }}</th>
              <th class="bg-lightgrey">{{ $t("discount") }}</th>
              <th class="bg-lightgrey text-right">{{ $t("balance") }}</th>
            </tr>
          </thead>
          <tbody
            v-if="
              getDailyReportList.length === 0 &&
              getDailyConcessionReportList.length === 0
            "
          >
            <tr rowspan="12">
              <td colspan="12">
                <!-- {{ `No Records Found` }} -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
          <tbody
            v-for="(
              dailyReportItem, dailyReportItemIndex
            ) in getDailyReportList"
            :key="dailyReportItemIndex"
          >
            <tr>
              <td rowspan="50" style="text-align: left">
                <strong>{{ dailyReportItem.Data[0].bs_source }}</strong>
              </td>
            </tr>

            <tr>
              <td rowspan="50">
                <strong>{{ dailyReportItem.Data[0].booking_user_name }}</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr style="background-color: rgba(169, 217, 251, 0.5)">
              <td>
                <strong>{{ dailyReportItem.Data[0].bs_source }}</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr
              v-for="(paymentMode, paymentModeIndex) in dailyReportItem.Data"
              :key="paymentModeIndex + paymentMode.tickets"
            >
              <td></td>
              <td>{{ paymentMode.payment_mode }}</td>
              <td>
                {{
                  paymentMode.offer_name != "" && paymentMode.offer_name != null
                    ? paymentMode.offer_name
                    : paymentMode.voucher_name != "" &&
                      paymentMode.voucher_name != null
                    ? paymentMode.voucher_name
                    : ""
                }}
              </td>
              <td>{{ paymentMode.tickets }}</td>
              <td>{{ currFormat(paymentMode.payment_mode_amount) }}</td>
              <td>{{ currFormat(paymentMode.cash_card_amount) }}</td>
              <td>{{ currFormat(paymentMode.gross_amount) }}</td>
              <td>{{ currFormat(paymentMode.net_revenue) }}</td>
              <td>{{ currFormat(paymentMode.discount) }}</td>
              <td class="text-right">
                {{ currFormat(paymentMode.gross_revenue) }}
              </td>
            </tr>

            <tr style="background-color: rgba(211, 211, 211, 0.4)">
              <td>
                <strong
                  >{{ dailyReportItem.Data[0].bs_source }}
                  {{ $t("total") }}</strong
                >
              </td>
              <td></td>

              <td>
                <!-- <strong>{{ dailyReportItem.payments.reduce(function(accumulator, { total_seats }) { return accumulator + parseFloat(total_seats); },0) }}</strong> -->
              </td>
              <td>
                <!-- <strong>2.00</strong> -->
                <strong>{{
                  dailyReportItem.Data.reduce(function (
                    accumulator,
                    { tickets }
                  ) {
                    return accumulator + parseFloat(tickets);
                  },
                  0)
                }}</strong>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { payment_mode_amount }
                    ) {
                      return accumulator + parseFloat(payment_mode_amount);
                    },
                    0)
                  )
                }}</strong>
                <!-- <strong>0.00</strong> -->
              </td>
              <td>
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { cash_card_amount }
                    ) {
                      return accumulator + parseFloat(cash_card_amount);
                    },
                    0)
                  )
                }}</strong>
                <!-- <strong>0.00</strong> -->
              </td>
              <td>
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { gross_amount }
                    ) {
                      return accumulator + parseFloat(gross_amount);
                    },
                    0)
                  )
                }}</strong>
                <!-- <strong>0.00</strong> -->
              </td>
              <td>
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { net_revenue }
                    ) {
                      return accumulator + parseFloat(net_revenue);
                    },
                    0)
                  )
                }}</strong>
                <!-- <strong>0.00</strong> -->
              </td>
              <td>
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { discount }
                    ) {
                      return accumulator + parseFloat(discount);
                    },
                    0)
                  )
                }}</strong>
                <!-- <strong>3.00</strong> -->
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { gross_revenue }
                    ) {
                      return accumulator + parseFloat(gross_revenue);
                    },
                    0)
                  )
                }}</strong>
              </td>
            </tr>
            <tr
              v-if="dailyReportItem.DataRefund"
              style="background-color: rgba(246, 194, 188, 0.5)"
            >
              <td>
                <strong>{{ $t("refund") }}</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-else></tr>

            <tr
              v-for="(
                paymentMode1, paymentMode1Index
              ) in dailyReportItem.DataRefund"
              :key="paymentMode1Index + paymentMode1.payment_mode"
            >
              <td></td>
              <td>{{ paymentMode1.payment_mode }}</td>
              <td>
                {{
                  paymentMode1.offer_name != "" || null
                    ? paymentMode1.offer_name
                    : paymentMode1.voucher_name != "" || null
                    ? paymentMode1.voucher_name
                    : ""
                }}
              </td>
              <td>{{ paymentMode1.tickets }}</td>
              <td></td>
              <td></td>
              <td>{{ currFormat(paymentMode1.gross_amount) }}</td>
              <td>{{ currFormat(paymentMode1.net_revenue) }}</td>
              <td>{{ currFormat(paymentMode1.discount) }}</td>
              <td class="text-right">
                {{ currFormat(paymentMode1.gross_revenue) }}
              </td>
            </tr>

            <tr
              v-if="dailyReportItem.DataRefund"
              style="background-color: rgba(211, 211, 211, 0.4)"
            >
              <td>
                <strong>{{ $tc("refund", 2) }} {{ $t("total") }}</strong>
              </td>
              <td></td>
              <td></td>
              <td>
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { tickets }
                    ) {
                      return accumulator + parseFloat(tickets);
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td></td>
              <td></td>
              <td>
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { gross_amount }
                    ) {
                      return accumulator + parseFloat(gross_amount);
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { net_revenue }
                    ) {
                      return accumulator + parseFloat(net_revenue);
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { discount }
                    ) {
                      return accumulator + parseFloat(discount);
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { gross_revenue }
                    ) {
                      return accumulator + parseFloat(gross_revenue);
                    },
                    0)
                  )
                }}</strong>
              </td>
            </tr>
            <tr v-else></tr>

            <tr>
              <td>
                <strong
                  >{{ dailyReportItem.Data[0].bs_source }} {{ $t("final") }}
                  {{ $t("total") }}</strong
                >
              </td>
              <td></td>
              <td></td>

              <td>
                <strong>{{
                  dailyReportItem.DataRefund
                    ? dailyReportItem.Data.reduce(function (
                        accumulator,
                        { tickets }
                      ) {
                        return accumulator + parseFloat(tickets);
                      },
                      0) -
                      dailyReportItem.DataRefund.reduce(function (
                        accumulator,
                        { tickets }
                      ) {
                        return accumulator + parseFloat(tickets);
                      },
                      0)
                    : dailyReportItem.Data.reduce(function (
                        accumulator,
                        { tickets }
                      ) {
                        return accumulator + parseFloat(tickets);
                      },
                      0)
                }}</strong>
              </td>
              <td></td>
              <td></td>
              <td>
                <strong>{{
                  dailyReportItem.DataRefund
                    ? currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { gross_amount }
                        ) {
                          return accumulator + parseFloat(gross_amount);
                        },
                        0) -
                          dailyReportItem.DataRefund.reduce(function (
                            accumulator,
                            { gross_amount }
                          ) {
                            return accumulator + parseFloat(gross_amount);
                          },
                          0)
                      )
                    : currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { gross_amount }
                        ) {
                          return accumulator + parseFloat(gross_amount);
                        },
                        0)
                      )
                }}</strong>
              </td>
              <td>
                <strong>{{
                  dailyReportItem.DataRefund
                    ? currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { net_revenue }
                        ) {
                          return accumulator + parseFloat(net_revenue);
                        },
                        0) -
                          dailyReportItem.DataRefund.reduce(function (
                            accumulator,
                            { net_revenue }
                          ) {
                            return accumulator + parseFloat(net_revenue);
                          },
                          0)
                      )
                    : currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { net_revenue }
                        ) {
                          return accumulator + parseFloat(net_revenue);
                        },
                        0)
                      )
                }}</strong>
              </td>
              <td>
                <strong>{{
                  dailyReportItem.DataRefund
                    ? currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { discount }
                        ) {
                          return accumulator + parseFloat(discount);
                        },
                        0) -
                          dailyReportItem.DataRefund.reduce(function (
                            accumulator,
                            { discount }
                          ) {
                            return accumulator + parseFloat(discount);
                          },
                          0)
                      )
                    : currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { discount }
                        ) {
                          return accumulator + parseFloat(discount);
                        },
                        0)
                      )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  dailyReportItem.DataRefund
                    ? currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { gross_revenue }
                        ) {
                          return accumulator + parseFloat(gross_revenue);
                        },
                        0) -
                          dailyReportItem.DataRefund.reduce(function (
                            accumulator,
                            { gross_revenue }
                          ) {
                            return accumulator + parseFloat(gross_revenue);
                          },
                          0)
                      )
                    : currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { gross_revenue }
                        ) {
                          return accumulator + parseFloat(gross_revenue);
                        },
                        0)
                      )
                }}</strong>
              </td>
            </tr>
          </tbody>

          <!-- //for refund data -->
          <!-- <tbody v-if="getDailyRefundList.length == 0"></tbody>
          <tbody
            v-for="(dailyRefundItem, dailyRefundItemIndex) in getDailyRefundList"
            :key="dailyRefundItemIndex "
          >
            <tr>
              <td></td>
              <td></td>
              <td>
                <strong>{{ $t('Refund') }}</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>

            <tr
              v-for="(paymentMode,paymentModeIndex) in dailyRefundItem.Data"
              :key="paymentModeIndex "
            >
              <td></td>
              <td></td>
              <td></td>
              <td>{{ paymentMode.payment_mode}}</td>
              <td>{{ paymentMode.offer_name != '' || null ? paymentMode.offer_name : paymentMode.voucher_name != '' || null ? paymentMode.voucher_name:''}}</td>
              <td>{{ paymentMode.tickets}}</td>
              <td>{{paymentMode.net_revenue}}</td>
              <td>{{paymentMode.discount}}</td>
              <td>{{paymentMode.gross_revenue}}</td>
            </tr>
          </tbody>-->

          <!-- <tbody v-if="getDailyReportList.length > 0">
            <tr>
              <td colspan="5">
                <strong>{{ $t('boxoffice') }}</strong>
              </td>

              <td>
                <strong>{{ getBoxOfficeTotal.totalNumberOfTickets }}</strong>
              </td>
              <td>
                <strong>{{ getBoxOfficeTotal.totalNetRevenue.toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
              </td>
              <td>
                <strong>0.00</strong>
              </td>
              <td>
                <strong>{{ getBoxOfficeTotal.totalGrossRevenue.toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
              </td>
            </tr>
          </tbody>-->

          <tbody
            v-for="(
              DailyConcessionReportItem, DailyConcessionReportItemIndex
            ) in getDailyConcessionReportList"
            :key="DailyConcessionReportItemIndex"
          >
            <tr>
              <td rowspan="9">
                <strong>{{ $t("concession") }}</strong>
              </td>
            </tr>
            <tr>
              <td rowspan="9">
                <strong
                  >{{ DailyConcessionReportItem.first_name }}&nbsp;{{
                    DailyConcessionReportItem.last_name
                  }}</strong
                >
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                <strong>{{ $t("concession") }}</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>

            <tr
              v-for="(
                TransactionItem, TransactionIndex
              ) in DailyConcessionReportItem.transactions"
              :key="TransactionIndex"
            >
              <td></td>
              <td>{{ TransactionItem.pm_payment_mode }}</td>
              <td></td>
              <td>{{ TransactionItem.number_of_tickets }}</td>
              <td>{{ currFormat(TransactionItem.net_revenue) }}</td>
              <td>0.00</td>
              <td>{{ currFormat(TransactionItem.gross_revenue) }}</td>
            </tr>

            <tr>
              <td>
                <strong></strong>
              </td>
              <td>
                <strong>{{ $t("concession") }}</strong>
              </td>
              <td>
                <strong></strong>
              </td>
              <td>
                <strong>{{
                  DailyConcessionReportItem.transactions.reduce(function (
                    accumulator,
                    { number_of_tickets }
                  ) {
                    return accumulator + parseFloat(number_of_tickets);
                  },
                  0)
                }}</strong>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    DailyConcessionReportItem.transactions.reduce(function (
                      accumulator,
                      { net_revenue }
                    ) {
                      return accumulator + parseFloat(net_revenue);
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td>0.00</td>

              <td class="text-right">
                <strong>{{
                  currFormat(
                    DailyConcessionReportItem.transactions.reduce(function (
                      accumulator,
                      { gross_revenue }
                    ) {
                      return accumulator + parseFloat(gross_revenue);
                    },
                    0)
                  )
                }}</strong>
              </td>
            </tr>
          </tbody>

          <tbody v-if="getDailyConcessionReportList.length > 0">
            <tr>
              <td colspan="5">
                <strong>{{ $t("concession") }}</strong>
              </td>
              <td>
                <strong>{{
                  getConcessionOfficeTotal.totalNumberOfTickets
                }}</strong>
              </td>
              <td>
                <strong>{{
                  currFormat(getConcessionOfficeTotal.totalNetRevenue)
                }}</strong>
              </td>
              <td>0.00</td>
              <td class="text-right">
                <strong>{{
                  currFormat(getConcessionOfficeTotal.totalGrossRevenue)
                }}</strong>
              </td>
            </tr>
          </tbody>

          <tbody
            v-if="
              getDailyConcessionReportList.length > 0 ||
              getDailyReportList.length > 0
            "
          >
            <tr>
              <td class="bg-lightgrey text-left">
                <strong>{{ $t("grand") }} {{ $t("total") }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong>{{ getGrandTotal.totalNumberOfTickets }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong>{{
                  currFormat(getGrandTotal.totalGrossAmount)
                }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong v-if="getGrandTotal.totalNetRevenue">{{
                  currFormat(getGrandTotal.totalNetRevenue)
                }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong v-if="getGrandTotal.totalDiscount">{{
                  currFormat(getGrandTotal.totalDiscount)
                }}</strong>
              </td>
              <td class="bg-lightgrey text-right">
                <strong getGrandTotal.totalGrossRevenue>{{
                  currFormat(getGrandTotal.totalGrossRevenue)
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- New table design -->
      <div v-if="false" class="row mx-0 mt-3 reports-box">
        <div class="col-2">
          <p class="light-title">Outlet</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-2">
          <p class="light-title">Username</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-2">
          <p class="light-title">Item</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-2">
          <p class="light-title">Payment Type</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-2">
          <p class="light-title">Offer</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-2">
          <p class="light-title">Quantity</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-12">
          <hr class="my-2" />
        </div>
        <div class="col-2">
          <p class="light-title">Gross Revenue</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-2">
          <p class="light-title">Net Revenue</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-2">
          <p class="light-title">Discount</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-2">
          <p class="light-title">Balance</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-12">
          <hr class="my-2" />
        </div>
      </div>

      <div v-if="getCashRefundVoucher.length > 0" class="swc-report mt-3">
        <table border="1" class="swc-report-table" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="8">Refund of Cash against voucher</th>
            </tr>
            <tr class="bg-lightgrey">
              <th class="text-left">SR. No</th>
              <th>Outlet</th>
              <th>Name Of Voucher</th>
              <th>Type Of voucher</th>
              <th>Gross Value of Voucher</th>
              <th class="text-right">Consumed Valued</th>
              <th class="text-right">Refund Value</th>
              <th class="text-right">Payment Type</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(UserItem, UserIndex) in getCashRefundVoucher"
              :key="UserIndex"
            >
              <td class="text-left">{{ UserIndex + 1 }}</td>
              <td>{{ UserItem.outlet }}</td>
              <td>{{ UserItem.voucher_name }}</td>
              <td>{{ UserItem.voucher_type }}</td>
              <td>{{ currFormat(UserItem.totalVoucherAmount) }}</td>
              <td>{{ currFormat(UserItem.t_gross_amount_before_offer) }}</td>
              <td>{{ currFormat(UserItem.cash_refund_amount) }}</td>
              <td>{{ UserItem.pm_payment_mode }}</td>
            </tr>
            <!-- <tr>
              <td>Box Office</td>
              <td>Liya</td>
              <td>5,623</td>
              <td>0.00</td>
              <td>0.00</td>
              <td>5,623.00</td>
            </tr>-->

            <tr class="bg-lightgrey">
              <td colspan="4" class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>

              <td>
                <strong>{{
                  currFormat(
                    getCashRefundVoucher.reduce(function (
                      accumulator,
                      { totalVoucherAmount }
                    ) {
                      return accumulator + parseFloat(totalVoucherAmount);
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    getCashRefundVoucher.reduce(function (
                      accumulator,
                      { t_gross_amount_before_offer }
                    ) {
                      return (
                        accumulator + parseFloat(t_gross_amount_before_offer)
                      );
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    getCashRefundVoucher.reduce(function (
                      accumulator,
                      { cash_refund_amount }
                    ) {
                      return accumulator + parseFloat(cash_refund_amount);
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="getSaleCashCard.length > 0" class="swc-report mt-3">
        <table border="1" class="swc-report-table" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="7">Sale of Cash Card</th>
            </tr>
            <tr class="bg-lightgrey">
              <th class="text-left">SR. No</th>
              <th>Issuer</th>
              <th>No of Cash Card</th>
              <th>Value Per Cash Card</th>
              <th class="">Processing Fee</th>
              <th class="">Total</th>
              <th class="">Payment Type</th>
              <th class="">View Cash Card List</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(UserItem, UserIndex) in getSaleCashCard"
              :key="UserIndex"
            >
              <td class="text-left">{{ UserIndex + 1 }}</td>
              <td>{{ UserItem.cash_Card_issuer }}</td>
              <td>{{ UserItem.no_of_cash_card }}</td>
              <td>{{ currFormat(UserItem.payment_value) }}</td>
              <td>{{ currFormat(UserItem.processing_fee) }}</td>
              <td>{{ currFormat(UserItem.total) }}</td>
              <td>{{ UserItem.payment_mode_name }}</td>
              <td>
                <span
                  class="icon-eye mr-1"
                  @click="showCardList(UserItem)"
                ></span>
              </td>
            </tr>
            <!-- <tr>
              <td>Box Office</td>
              <td>Liya</td>
              <td>5,623</td>
              <td>0.00</td>
              <td>0.00</td>
              <td>5,623.00</td>
            </tr>-->

            <tr class="bg-lightgrey">
              <td colspan="2" class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td>
                <strong>{{
                  getSaleCashCard.reduce(function (
                    accumulator,
                    { no_of_cash_card }
                  ) {
                    return accumulator + parseFloat(no_of_cash_card);
                  },
                  0)
                }}</strong>
              </td>
              <td></td>
              <td>
                <strong>{{
                  currFormat(
                    getSaleCashCard.reduce(function (
                      accumulator,
                      { processing_fee }
                    ) {
                      return accumulator + parseFloat(processing_fee);
                    },
                    0)
                  )
                }}</strong>
              </td>

              <td>
                <strong>{{
                  currFormat(
                    getSaleCashCard.reduce(function (accumulator, { total }) {
                      return accumulator + parseFloat(total);
                    }, 0)
                  )
                }}</strong>
              </td>
              <td class="text-right">
                <!-- <strong>{{
                  currFormat(
                    getSaleCashCard.reduce(function(
                      accumulator,
                      { cash_refund_amount }
                    ) {
                      return (
                        accumulator +
                        (parseFloat(cash_refund_amount))
                      );
                    },
                    0)
                  )
                }}</strong> -->
              </td>
              <!-- <td></td> -->
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="getTopUpCashCard.length > 0" class="swc-report mt-3">
        <table border="1" class="swc-report-table" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="3">Topup Cash Card</th>
            </tr>
            <tr class="bg-lightgrey">
              <th class="text-left">SR. No</th>
              <th>Payment Mode</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(UserItem, UserIndex) in getTopUpCashCard"
              :key="UserIndex"
            >
              <td class="text-left">{{ UserIndex + 1 }}</td>
              <td>{{ UserItem.pm_payment_mode }}</td>

              <td>{{ currFormat(UserItem.amount) }}</td>
            </tr>

            <tr class="bg-lightgrey">
              <td colspan="2" class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    getTopUpCashCard.reduce(function (accumulator, { amount }) {
                      return accumulator + parseFloat(amount);
                    }, 0)
                  )
                }}</strong>
              </td>

              <!-- <td></td> -->
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="getPaymentSummary.length > 0" class="swc-report mt-3">
        <table class="swc-report-table" border="1" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="5">
                {{ $tc("payment", 1) }} {{ $t("type") }} {{ $t("wise") }}
                {{ $t("summary") }}
              </th>
            </tr>
            <tr class="bg-lightgrey text-left">
              <th rowspan="2">
                {{ $t("outlet") }}
              </th>
              <th>
                {{ $tc("payment", 1) }} {{ $tc("type", 1) }} / <br />
                {{ $t("partner") }}
              </th>
              <th>{{ $t("current") }} sold</th>
              <th>{{ $t("advance") }} {{ $t("sold") }} {{ $t("today") }}</th>
              <th rowspan="2" class="text-right">Total</th>
            </tr>
            <tr class="bg-lightgrey">
              <th class="text-center">{{ $t("partners") }}</th>
              <th>
                <table class="fixed-layout-table">
                  <thead>
                    <tr>
                      <th class="text-center">{{ $tc("ticket", 1) }}</th>
                      <th class="text-center">
                        {{ $tc("Payment Mode Amount", 1) }}
                      </th>
                      <th class="text-center">
                        {{ $tc("Cash Card Amount", 1) }}
                      </th>
                      <th class="text-center">
                        {{ $t("total") }} {{ $t("net") }}
                      </th>
                      <th class="text-center">
                        {{ $t("total") }} {{ $t("gross") }}
                      </th>
                    </tr>
                  </thead>
                </table>
              </th>
              <th>
                <table class="fixed-layout-table">
                  <thead>
                    <tr>
                      <th class="text-center">{{ $tc("ticket", 1) }}</th>
                      <th class="text-center">
                        {{ $tc("Payment Mode Amount", 1) }}
                      </th>
                      <th class="text-center">
                        {{ $tc("Cash Card Amount", 1) }}
                      </th>
                      <th class="text-center">
                        {{ $t("total") }} {{ $t("net") }}
                      </th>
                      <th class="text-center">
                        {{ $t("total") }} {{ $t("gross") }}
                      </th>
                    </tr>
                  </thead>
                </table>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(Payment, PaymentIndex) in getPaymentSummary"
              :key="PaymentIndex"
            >
              <td class="text-left">{{ Payment.bs_source }}</td>
              <td>{{ Payment.pm_payment_mode }}</td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <td class="text-center">{{ Payment.tickets }}</td>
                    <td class="text-center">
                      {{ currFormat(Payment.payment_mode_amount) }}
                    </td>
                    <td class="text-center">
                      {{ currFormat(Payment.cash_card_amount) }}
                    </td>
                    <td class="text-center">
                      {{ currFormat(Payment.net_amount) }}
                    </td>
                    <td class="text-center">
                      {{ currFormat(Payment.gross_amount) }}
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <td class="text-center">{{ Payment.advanceTickets }}</td>
                    <td class="text-center">
                      {{ currFormat(Payment.advance_payment_mode_amount) }}
                    </td>
                    <td class="text-center">
                      {{ currFormat(Payment.advance_cash_card_amount) }}
                    </td>
                    <td class="text-center">
                      {{ currFormat(Payment.advanceNetAmount) }}
                    </td>
                    <td class="text-center">
                      {{ currFormat(Payment.advanceGrossAmount) }}
                    </td>
                  </tr>
                </table>
              </td>
              <td class="text-right">
                {{
                  currFormat(Payment.gross_amount + Payment.advanceGrossAmount)
                }}
              </td>
            </tr>
            <tr class="bg-lightgrey">
              <td colspan="2" class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <td class="text-center">
                      {{
                        getPaymentSummary.reduce(function (
                          accumulator,
                          { tickets }
                        ) {
                          return accumulator + parseFloat(tickets);
                        },
                        0)
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { payment_mode_amount }
                          ) {
                            return (
                              accumulator + parseFloat(payment_mode_amount)
                            );
                          },
                          0)
                        )
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { cash_card_amount }
                          ) {
                            return accumulator + parseFloat(cash_card_amount);
                          },
                          0)
                        )
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { net_amount }
                          ) {
                            return accumulator + parseFloat(net_amount);
                          },
                          0)
                        )
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { gross_amount }
                          ) {
                            return accumulator + parseFloat(gross_amount);
                          },
                          0)
                        )
                      }}
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <td class="text-center">
                      {{
                        getPaymentSummary.reduce(function (
                          accumulator,
                          { advanceTickets }
                        ) {
                          return accumulator + parseFloat(advanceTickets);
                        },
                        0)
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { advance_payment_mode_amount }
                          ) {
                            return (
                              accumulator +
                              parseFloat(advance_payment_mode_amount)
                            );
                          },
                          0)
                        )
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { advance_cash_card_amount }
                          ) {
                            return (
                              accumulator + parseFloat(advance_cash_card_amount)
                            );
                          },
                          0)
                        )
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { advanceNetAmount }
                          ) {
                            return accumulator + parseFloat(advanceNetAmount);
                          },
                          0)
                        )
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { advanceGrossAmount }
                          ) {
                            return accumulator + parseFloat(advanceGrossAmount);
                          },
                          0)
                        )
                      }}
                    </td>
                  </tr>
                </table>
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    getPaymentSummary.reduce(function (
                      accumulator,
                      { advanceGrossAmount, gross_amount }
                    ) {
                      return (
                        accumulator +
                        parseFloat(gross_amount) +
                        parseFloat(advanceGrossAmount)
                      );
                    },
                    0)
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="getOverAllSummary.length > 0" class="swc-report mt-3">
        <table class="swc-report-table" border="1" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="5">
                {{ $t("summary") }}
              </th>
            </tr>
            <tr class="bg-lightgrey">
              <th>{{ $t("Channel") }}</th>
              <th>{{ "Sale" }}</th>
              <th>{{ "Refund" }}</th>
              <th>{{ "Balance" }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(overallSummary, overallSummaryIndex) in getOverAllSummary"
              :key="overallSummaryIndex"
            >
              <td class="text-left">
                {{ currFormat(overallSummary.bs_source) }}
              </td>
              <td class="text-right">
                {{ currFormat(overallSummary.payment_mode_amount) }}
              </td>
              <td class="text-right">
                {{ currFormat(overallSummary.refundAmount) }}
              </td>
              <td class="text-right">
                {{ currFormat(overallSummary.balance) }}
              </td>
            </tr>
            <tr class="bg-lightgrey">
              <td class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    getOverAllSummary.reduce(
                      (accumulator, { payment_mode_amount }) => {
                        return (
                          accumulator + parseFloat(payment_mode_amount || 0)
                        );
                      },
                      0
                    )
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    getOverAllSummary.reduce(
                      (accumulator, { refundAmount }) => {
                        return accumulator + parseFloat(refundAmount || 0);
                      },
                      0
                    )
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    getOverAllSummary.reduce((accumulator, { balance }) => {
                      return accumulator + parseFloat(balance || 0);
                    }, 0)
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="getFilmSummary.length > 0" class="swc-report mt-3">
        <table class="swc-report-table" border="1" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="5">Film Wise Summary</th>
            </tr>
            <tr class="bg-lightgrey">
              <th rowspan="2" class="text-left">Movie</th>
              <th>{{ $t("current") }}</th>
              <th>{{ $t("advance") }} {{ $t("sold") }} {{ $t("today") }}</th>
              <th rowspan="2" class="text-right">Total</th>
            </tr>
            <tr class="bg-lightgrey">
              <th>
                <table class="fixed-layout-table">
                  <thead>
                    <tr>
                      <th class="text-center">{{ $tc("ticket", 1) }}</th>
                      <th class="text-center">
                        {{ $t("total") }} {{ $t("net") }}
                      </th>
                      <th class="text-center">
                        {{ $t("total") }} {{ $t("gross") }}
                      </th>
                    </tr>
                  </thead>
                </table>
              </th>
              <th>
                <table class="fixed-layout-table">
                  <thead>
                    <tr>
                      <th class="text-center">{{ $tc("ticket", 1) }}</th>
                      <th class="text-center">
                        {{ $t("total") }} {{ $t("net") }}
                      </th>
                      <th class="text-center">
                        {{ $t("total") }} {{ $t("gross") }}
                      </th>
                    </tr>
                  </thead>
                </table>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(filmItem, filmIndex) in getFilmSummary"
              :key="filmIndex"
            >
              <td>
                <strong>{{ filmItem.movie }}</strong>
              </td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <td class="text-center">{{ filmItem.ticket }}</td>
                    <td class="text-center">
                      {{ currFormat(filmItem.net_amount) }}
                    </td>
                    <td class="text-center">
                      {{ currFormat(filmItem.gross_amount) }}
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <td class="text-center">{{ filmItem.advanceTickets }}</td>
                    <td class="text-center">
                      {{ currFormat(filmItem.advanceNetAmount) }}
                    </td>
                    <td class="text-center">
                      {{ currFormat(filmItem.advanceGrossAmount) }}
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                {{
                  currFormat(
                    filmItem.gross_amount + filmItem.advanceGrossAmount
                  )
                }}
              </td>
            </tr>

            <tr class="bg-lightgrey">
              <td class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <td class="text-center">
                      <strong>{{
                        currFormat(
                          getFilmSummary.reduce(function (
                            accumulator,
                            { ticket }
                          ) {
                            return accumulator + parseFloat(ticket);
                          },
                          0)
                        )
                      }}</strong>
                    </td>
                    <td class="text-center">
                      <strong>{{
                        currFormat(
                          getFilmSummary.reduce(function (
                            accumulator,
                            { net_amount }
                          ) {
                            return accumulator + parseFloat(net_amount);
                          },
                          0)
                        )
                      }}</strong>
                    </td>
                    <td class="text-center">
                      <strong>{{
                        currFormat(
                          getFilmSummary.reduce(function (
                            accumulator,
                            { gross_amount }
                          ) {
                            return accumulator + parseFloat(gross_amount);
                          },
                          0)
                        )
                      }}</strong>
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <td class="text-center">
                      <strong>{{
                        currFormat(
                          getFilmSummary.reduce(function (
                            accumulator,
                            { advanceTickets }
                          ) {
                            return accumulator + parseFloat(advanceTickets);
                          },
                          0)
                        )
                      }}</strong>
                    </td>
                    <td class="text-center">
                      <strong>{{
                        currFormat(
                          getFilmSummary.reduce(function (
                            accumulator,
                            { advanceNetAmount }
                          ) {
                            return accumulator + parseFloat(advanceNetAmount);
                          },
                          0)
                        )
                      }}</strong>
                    </td>
                    <td class="text-center">
                      <strong>{{
                        currFormat(
                          getFilmSummary.reduce(function (
                            accumulator,
                            { advanceGrossAmount }
                          ) {
                            return accumulator + parseFloat(advanceGrossAmount);
                          },
                          0)
                        )
                      }}</strong>
                    </td>
                  </tr>
                </table>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    getFilmSummary.reduce(function (
                      accumulator,
                      { advanceGrossAmount, gross_amount }
                    ) {
                      return (
                        accumulator +
                        parseFloat(advanceGrossAmount) +
                        parseFloat(gross_amount)
                      );
                    },
                    0)
                  )
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="getUserWiseSummary.length > 0" class="swc-report mt-3">
        <table border="1" class="swc-report-table" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="6">
                {{ $tc("user") }} {{ $tc("wise") }} {{ $tc("summary") }}
              </th>
            </tr>
            <tr class="bg-lightgrey">
              <th class="text-left">{{ $t("outlet") }}</th>
              <th>{{ $tc("user", 1) }} {{ $t("name") }}</th>
              <th>{{ $t("current") }}</th>
              <th>{{ $t("advance") }} {{ $t("sold") }} {{ $t("today") }}</th>
              <th class="text-right">{{ $t("total") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(UserItem, UserIndex) in getUserWiseSummary"
              :key="UserIndex"
            >
              <td class="text-left">{{ UserItem.bs_source }}</td>
              <td>{{ UserItem.booking_user_name }}</td>
              <td>{{ currFormat(UserItem.gross_amount) }}</td>
              <td>{{ currFormat(UserItem.advanceGrossAmount) }}</td>
              <td class="text-right">
                {{
                  currFormat(
                    UserItem.advanceGrossAmount + UserItem.gross_amount
                  )
                }}
              </td>
            </tr>
            <!-- <tr>
              <td>Box Office</td>
              <td>Liya</td>
              <td>5,623</td>
              <td>0.00</td>
              <td>0.00</td>
              <td>5,623.00</td>
            </tr>-->

            <tr class="bg-lightgrey">
              <td colspan="2" class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    getUserWiseSummary.reduce(function (
                      accumulator,
                      { gross_amount }
                    ) {
                      return accumulator + parseFloat(gross_amount);
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    getUserWiseSummary.reduce(function (
                      accumulator,
                      { advanceGrossAmount }
                    ) {
                      return accumulator + parseFloat(advanceGrossAmount);
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    getUserWiseSummary.reduce(function (
                      accumulator,
                      { gross_amount, advanceGrossAmount }
                    ) {
                      return (
                        accumulator +
                        (parseFloat(advanceGrossAmount) +
                          parseFloat(gross_amount))
                      );
                    },
                    0)
                  )
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="getRefundSummary.length > 0" class="swc-report mt-3">
        <table border="1" class="swc-report-table" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="5">{{ $tc("refund", 1) }} {{ $t("summary") }}</th>
            </tr>
            <tr class="bg-lightgrey">
              <th class="text-left">{{ $t("outlet") }}</th>
              <th>{{ $tc("user", 1) }}</th>
              <th>{{ $tc("payment", 1) }} {{ $tc("type", 1) }}</th>
              <th>{{ $tc("ticket", 1) }}</th>
              <th class="text-right">
                {{ $tc("refund", 1) }} {{ $t("value") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(RefundItem, RefundIndex) in getRefundSummary"
              :key="RefundIndex"
            >
              <td class="text-left">{{ RefundItem.bs_source }}</td>
              <td>{{ RefundItem.username }}</td>
              <td>{{ RefundItem.pm_payment_mode }}</td>
              <td>{{ RefundItem.tickets }}</td>
              <td class="text-right">{{ currFormat(RefundItem.refund) }}</td>
            </tr>
            <!-- <tr>
              <td>Box Office</td>
              <td>Charity</td>
              <td>Cash</td>
              <td>3</td>
              <td>110.25</td>
            </tr>-->
            <tr class="bg-lightgrey">
              <td class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td>
                <strong></strong>
              </td>
              <td>
                <strong></strong>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    getRefundSummary.reduce(function (
                      accumulator,
                      { tickets }
                    ) {
                      return accumulator + parseFloat(tickets);
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    getRefundSummary.reduce(function (accumulator, { refund }) {
                      return accumulator + parseFloat(refund);
                    }, 0)
                  )
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="false" class="swc-report mt-3">
        <table border="1" class="swc-report-table" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="4">
                {{ $t("advance") }} {{ $t("sold") }} {{ $t("today") }}'s
                (20-Sep-2019) {{ $t("show") }}
              </th>
            </tr>
            <tr class="bg-lightgrey">
              <th class="text-left">{{ $t("outlet") }}</th>
              <th>{{ $tc("payment", 1) }} {{ $tc("type", 1) }}</th>
              <th>{{ $tc("ticket", 1) }}</th>
              <th class="text-right">{{ $t("rrevenue") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-left">{{ $t("boxoffice") }}</td>
              <td>{{ $t("cash") }}</td>
              <td>6</td>
              <td class="text-right">189.00</td>
            </tr>

            <tr class="bg-lightgrey">
              <td colspan="2" class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td>
                <strong>21</strong>
              </td>
              <td class="text-right">
                <strong>787.77</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- DAILY CONCESSION REPORT -->
    <div class="white-wrapper">
      <h5>{{ $t("dailySalesConcessionReport") }}</h5>
      <div class="swc-report">
        <table border="1" class="swc-report swc-report-table">
          <thead class="bg-lightgrey">
            <tr>
              <th class="text-left">{{ $t("outlet") }}</th>
              <th>Username</th>
              <th class="p-0">
                <table class="fixed-layout-table table-elements-border">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Payment Type</th>
                      <th>Offer</th>
                      <th>Quantity</th>
                      <th>Payment Mode Amount</th>
                      <th>Cash Card Amount</th>
                      <!-- <th>Quantity</th> -->
                      <th>Gross Revenue</th>
                      <th>Net Revenue</th>
                      <th>Discount</th>
                      <th class="text-right">Balance</th>
                    </tr>
                  </thead>
                </table>
              </th>
            </tr>
          </thead>
          <tbody
            v-if="
              getConcessionDailyReportData &&
              getConcessionDailyReportData.length == 0
            "
          >
            <tr rowspan="12">
              <td colspan="12">
                <!-- {{ `No Records Found` }} -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
          <tbody
            v-else-if="
              getConcessionDailyReportData &&
              getConcessionDailyReportData.length > 0
            "
            class="sph-report"
          >
            <tr
              v-for="(
                ConcessionItem, ConcessionIndex
              ) in getConcessionDailyReportData"
              :key="ConcessionIndex"
            >
              <td class="text-left">
                {{
                  ConcessionItem.FnbItems[0].paymentTypes[0].fst_booking_source
                }}
              </td>
              <td>{{ ConcessionItem.FnbItems[0].paymentTypes[0].username }}</td>
              <td colspan="10" class="child-tables">
                <table
                  v-for="(FnbItem, FnbItemIndex) in ConcessionItem.FnbItems"
                  :key="FnbItemIndex"
                  class="fixed-layout-table"
                >
                  <tr
                    v-for="(PaymentItem, PaymentIndex) in FnbItem.paymentTypes"
                    :key="PaymentIndex"
                  >
                    <td>
                      {{ PaymentIndex == 0 ? PaymentItem.fst_item_name : "" }}
                    </td>
                    <td>{{ PaymentItem.fst_payment_mode }}</td>
                    <td>{{ PaymentItem.ft_offer_name || "-" }}</td>
                    <td>{{ PaymentItem.total_quantity }}</td>
                    <td>{{ currFormat(PaymentItem.payment_mode_amount) }}</td>
                    <td>{{ currFormat(PaymentItem.cash_card_amount) }}</td>
                    <td>{{ currFormat(PaymentItem.total_amount) }}</td>
                    <td>{{ currFormat(PaymentItem.net_amount) }}</td>
                    <td>{{ currFormat(PaymentItem["ft_offer_price"]) }}</td>
                    <td class="text-right">
                      {{ currFormat(PaymentItem["balance_amount"]) }}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
          <tbody v-if="getConcessionDailyReportData.length > 0">
            <tr>
              <td class="bg-lightgrey text-left">
                <strong>{{ $t("grand") }} {{ $t("total") }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="p-0">
                <table class="fixed-layout-table table-elements-border">
                  <thead>
                    <tr>
                      <td class="bg-lightgrey">
                        <strong></strong>
                      </td>
                      <td class="bg-lightgrey">
                        <strong></strong>
                      </td>
                      <td class="bg-lightgrey">
                        <strong></strong>
                      </td>
                      <!-- <td class="bg-lightgrey"> <td class="bg-lightgrey">
                        <strong v-if="getGrandTotalNew.totalRevenue">{{
                          currFormat(getGrandTotalNew.totalRevenue)
                        }}</strong>
                      </td>
                <strong>{{ getGrandTotal.totalNumberOfTickets }}</strong>
              </td> -->
                      <td class="bg-lightgrey">
                        <strong>{{ getGrandTotalNew.totalQuantity }}</strong>
                      </td>
                      <td class="bg-lightgrey">
                        <strong>{{
                          currFormat(getGrandTotalNew.totalPaymentModeAmount)
                        }}</strong>
                      </td>
                      <td class="bg-lightgrey">
                        <strong>{{
                          currFormat(getGrandTotalNew.totalCashCardAmount)
                        }}</strong>
                      </td>
                      <td class="bg-lightgrey">
                        <strong v-if="getGrandTotalNew.totalRevenue">{{
                          currFormat(getGrandTotalNew.totalRevenue)
                        }}</strong>
                      </td>
                      <td class="bg-lightgrey">
                        <strong v-if="getGrandTotalNew.totalNetAmount">{{
                          currFormat(getGrandTotalNew.totalNetAmount)
                        }}</strong>
                      </td>
                      <td class="bg-lightgrey">
                        <strong getGrandTotalNew.totalDiscount>{{
                          currFormat(getGrandTotalNew.totalDiscount)
                        }}</strong>
                      </td>
                      <td class="bg-lightgrey text-right">
                        <strong getGrandTotalNew.totalBalance>{{
                          currFormat(getGrandTotalNew.totalBalance)
                        }}</strong>
                      </td>
                    </tr>
                  </thead>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        v-if="
          getDailyReportList.length > 0 ||
          getDailyConcessionReportList.length > 0 ||
          getConcessionDailyReportData.length > 0
        "
        class="d-flex justify-content-end mt-5 align-items-center"
      >
        <div>{{ $t("download") }} as:</div>
        <a
          v-if="getDailyPDFFileName"
          :href="BASE_URL + getConcessionDailyPdfFileName"
          target="_blank"
          download
          title="Download as PDF"
        >
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </a>
        <a
          v-if="getDailyExcelFileName"
          :href="BASE_URL + getConcessionDailyExcelFileName"
          target="_blank"
          title="Download as Excel"
          download
        >
          <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </a>
      </div>
    </div>

    <!-- DAILY CONCESSION REPORT -->
    <div class="white-wrapper" v-if="FlatMerchandiseTransactions.length">
      <h5>Daily Merchandise Sales</h5>
      <div class="swc-report">
        <table border="1" class="swc-report swc-report-table">
          <thead class="bg-lightgrey">
            <tr>
              <th class="text-left">{{ $t("outlet") }}</th>
              <th>Username</th>
              <th>Payment Mode</th>
              <th class="p-0">
                <table class="fixed-layout-table table-elements-border">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Quantity</th>
                      <th>Offer</th>
                      <th>Discount</th>
                      <th>Net Revenue</th>
                      <th>Gross Revenue</th>
                    </tr>
                  </thead>
                </table>
              </th>
            </tr>
          </thead>
          <tbody
            v-if="
              FlatMerchandiseTransactions &&
              FlatMerchandiseTransactions.length == 0
            "
          >
            <tr rowspan="12">
              <td colspan="12">
                <!-- {{ `No Records Found` }} -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="FlatMerchandiseTransactions" class="sph-report">
            <tr
              v-for="(merchandiseKey, keyIndex) in Object.keys(
                MerchandiseTransactions
              )"
              :key="keyIndex"
            >
              <td class="text-left">
                {{
                  MerchandiseTransactions[merchandiseKey][0].booking_source ||
                  "-"
                }}
              </td>
              <td class="text-left">
                {{
                  MerchandiseTransactions[merchandiseKey][0].booking_user || "-"
                }}
              </td>
              <td class="text-left">
                {{
                  MerchandiseTransactions[merchandiseKey][0]
                    .payment_mode_name || "-"
                }}
              </td>
              <td colspan="10" class="child-tables">
                <table class="fixed-layout-table border" border="1">
                  <tr
                    v-for="(
                      merchItems, merchItemsIndex
                    ) in MerchandiseTransactions[merchandiseKey]"
                    :key="merchItemsIndex"
                  >
                    <td class="text-left">
                      {{ merchItems.merchandise_name || "" }}
                    </td>
                    <td>{{ merchItems.quantity || "" }}</td>
                    <td>{{ "-" }}</td>
                    <td>
                      {{
                        parseFloat(merchItems.m_offer_price || 0).toFixed(
                          MIN_FRACTION_DIGITS
                        )
                      }}
                    </td>
                    <td>
                      {{
                        parseFloat(merchItems.m_net_amount || 0).toFixed(
                          MIN_FRACTION_DIGITS
                        )
                      }}
                    </td>
                    <td>
                      {{
                        parseFloat(merchItems.m_gross_amount || 0).toFixed(
                          MIN_FRACTION_DIGITS
                        )
                      }}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
          <tbody v-if="FlatMerchandiseTransactions.length > 0">
            <tr>
              <td class="bg-lightgrey text-left">
                <strong>{{ $t("grand") }} {{ $t("total") }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="p-0">
                <table class="fixed-layout-table table-elements-border">
                  <thead>
                    <tr>
                      <td class="bg-lightgrey">
                        <strong></strong>
                      </td>
                      <td class="bg-lightgrey">
                        <strong></strong>
                      </td>
                      <td class="bg-lightgrey">
                        <strong></strong>
                      </td>
                      <td class="bg-lightgrey">
                        <strong>{{
                          parseFloat(
                            FlatMerchandiseTransactions.reduce(
                              (acc, { m_offer_price }) => acc + m_offer_price,
                              0
                            )
                          ).toFixed(MIN_FRACTION_DIGITS)
                        }}</strong>
                      </td>
                      <td class="bg-lightgrey">
                        <strong>{{
                          parseFloat(
                            FlatMerchandiseTransactions.reduce(
                              (acc, { m_net_amount }) => acc + m_net_amount,
                              0
                            )
                          ).toFixed(MIN_FRACTION_DIGITS)
                        }}</strong>
                      </td>
                      <td class="bg-lightgrey">
                        <strong>{{
                          parseFloat(
                            FlatMerchandiseTransactions.reduce(
                              (acc, { m_gross_amount }) => acc + m_gross_amount,
                              0
                            )
                          ).toFixed(MIN_FRACTION_DIGITS)
                        }}</strong>
                      </td>
                    </tr>
                  </thead>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- <div class="white-wrapper">
      <h5>Cashier Shift Summmary Report</h5>
      <table border="1" class="reports-table">
        <thead>
          <tr class="bg-lightgrey">
            <th>Ticket Sales W/O Refund</th>
            <th>Qty</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rowKey) in 5" :key="rowKey">
            <td>Point of Sale</td>
            <td>1</td>
            <td>150</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <strong>Grand Total</strong>
            </td>
            <td>
              <strong>1</strong>
            </td>
            <td>
              <strong>1500</strong>
            </td>
          </tr>
        </tfoot>
      </table>

      <div class="py-3"></div>

      <table border="1" class="reports-table">
        <thead>
          <tr class="bg-lightgrey">
            <th>Ticket Sales With Refund</th>
            <th>Qty</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rowKey) in 3" :key="rowKey">
            <td>Point of Sale</td>
            <td>1</td>
            <td>150</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <strong>Grand Total</strong>
            </td>
            <td>
              <strong>1</strong>
            </td>
            <td>
              <strong>1500</strong>
            </td>
          </tr>
        </tfoot>
      </table>

      <div class="py-3"></div>

      <table border="1" class="reports-table">
        <thead>
          <tr class="bg-lightgrey">
            <th>Refund Tickets Sold From</th>
            <th>Qty</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rowKey) in 2" :key="rowKey">
            <td>Point of Sale</td>
            <td>1</td>
            <td>150</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <strong>Grand Total</strong>
            </td>
            <td>
              <strong>1</strong>
            </td>
            <td>
              <strong>1500</strong>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>-->
    <b-modal id="cardDetails" title="Cash Cards" hide-footer hide-header>
      <div class="">
        <table
          class="list-view-table border m-0"
          v-if="showCardListNew.length > 0"
        >
          <thead>
            <tr>
              <th>{{ $tc("card") }} {{ $tc("number") }}</th>
              <th>{{ $tc("customer") }} {{ $tc("name") }}</th>
              <th class="text-right">
                <span class="">{{ $tc("status", 2) }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(card, key) in showCardListNew" :key="key">
              <td>{{ card.cash_card_number || "-" }}</td>
              <td>
                {{ card.customer_name ? card.customer_name : "Street Sale" }}
              </td>
              <td>
                <div class="d-flex align-items-center justify-content-end mr-4">
                  <StatusDot
                    :status="
                      card.cash_card_is_active === 'Y'
                        ? 'active'
                        : card.cash_card_is_active === 'N' && 'inactive'
                    "
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { BASEURL } from "@/config/index";
import ReportsServiceV2 from "@/services/ReportsService-v2";
import MasterService from "@/services/MasterService";
import NoRecords from "@/components/Partials/NoRecords.vue";
import StatusDot from "@/components/Partials/StatusDot.vue";
import moment from "moment-timezone";
import _ from "lodash";

export default {
  components: {
    NoRecords,
    StatusDot,
  },
  data() {
    return {
      BASEURL,
      FlatMerchandiseTransactions: [],
      MerchandiseTransactions: [],
      DailyReportDataV2: [],
      Cinemas: [],
      isRoleID: true,
      CinemasCopy: [],
      searchCinema: "",
      showCardListNew: [],
    };
  },
  computed: {
    getGrandTotalNew() {
      console.log(this.$store.getters.grandTotalForConcessionsReport);
      return this.$store.getters.grandTotalForConcessionsReport;
    },
    ...mapGetters([
      // GET LIST ONLY
      "getPosUsersList",
      "getPaymentTypesList",
      "getCinemasList",
      "getDailyConcessionReportList",
      // Flags
      "getDailyReportsIsCinema",
      "getDailyReportsIsExcelDownload",
      // Rendered List
      "getDailyReportList",
      "getDailyRefundList",
      // Selected Dates
      "getDailyReportToDate",
      "getDailyReportFromDate",
      // Selected Dropdowns
      "getDailyReportSelectedPaymentMode",
      "getDailyReportSelectedPosUser",
      "getDailyReportSelectedCinema",
      "getDailyReportSelectedCinemaId",
      "getDailyReportSelectedPmId",
      "getDailyReportSelectedUserId",
      // FILEs
      "getDailyExcelFileName",
      // PSD
      "getDailyPDFFileName",
      // GET TOTALs
      "getGrandTotal",
      "getBoxOfficeTotal",
      "getConcessionOfficeTotal",
      "getPaymentSummary",
      "getOverAllSummary",
      "getFilmSummary",
      "getUserWiseSummary",
      "getCashRefundVoucher",
      "getSaleCashCard",
      "getTopUpCashCard",
      "getRefundSummary",
      "getConcessionDailyReportData",
      "grandTotalForConcessionsReport",
      "getConcessionDailyExcelFileName",
      "getConcessionDailyPdfFileName",
    ]),
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.onDailyReportDropdownHandler({
          event: null,
          name: "Cinema",
          selectedItem: CinemaObj,
        });
      }
    },
  },
  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    // this.onDailyReportFlagHandler({
    //   event: null,
    //   name: "isCinema",
    //   value: cinemaId
    // });
    // this.fetchCinemasList({ cinemaId });
    // this.fetchPosUsersList();
    this.getCinemaList(cinemaId);
    this.fetchPaymentTypesList();

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onDailyReportDropdownHandler({
        event: null,
        name: "Cinema",
        selectedItem: CinemaObj,
      });
    }
  },
  mounted() {},
  methods: {
    moment,
    showCardList(item) {
      this.showCardListNew = [];
      this.showCardListNew = item.cashCardDetails;
      // this.showCardListNew = item.cards.split(",");
      console.log(this.showCardListNew);
      this.$bvModal.show("cardDetails");
    },
    onSelectCinema(cinema) {
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    setLabel(event) {
      if (event.first_name && event.first_name.length > 0) {
        return `${event.first_name ? event.first_name : ""} ${
          event.middle_name ? event.middle_name : ""
        } ${event.last_name ? event.last_name : ""}`;
      } else {
        return "All";
      }
    },
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onFetchReport() {
      this.fetchDailyReportListv2({ OLD: true });
      this.onFetchDailyConcessionReport({ OLD: true });
      this.getMerchandiseTransactions();
    },
    getMerchandiseTransactions: function () {
      if (!this.getDailyReportSelectedCinemaId) {
        return this.$toasted.show("Please select Cinema");
      } else if (!this.getDailyReportToDate && !this.getDailyReportFromDate) {
        return this.$toasted.show("Please select Date");
      } else if (this.getDailyReportToDate && !this.getDailyReportFromDate) {
        return this.$toasted.show("Please select From date");
      } else if (this.getDailyReportFromDate && !this.getDailyReportToDate) {
        return this.$toasted.show("Please select TO date");
      } else if (
        moment(this.getDailyReportFromDate).isAfter(this.getDailyReportToDate)
      ) {
        return this.$toasted.show("From must be smaller than To Date");
      } else {
        // let loader = this.$loading.show();
        this.FlatMerchandiseTransactions = [];
        this.MerchandiseTransactions = [];
        this.btenable = true;
        let payload = {
                    cinema_id: this.getDailyReportSelectedCinemaId,
          fromDate: this.getDailyReportFromDate
            ? moment(this.getDailyReportFromDate).format("YYYY-MM-DD")
            : null,
          toDate: this.getDailyReportToDate
            ? moment(this.getDailyReportToDate).format("YYYY-MM-DD")
            : null,
          searchValue: "",
          limit: 100000,
          currentPage: 1,
          pm_id: this.getDailyReportSelectedPmId || null,
          user_id: this.getDailyReportSelectedUserId || null,
          cinema_id: this.getDailyReportSelectedCinemaId,
          isExcel: "N",
          exportType: "item",
        };

        MasterService.GetMerchandiseTransactions(payload)
          .then((response) => {
            const { data } = response;
            if (
              data &&
              data.status &&
              data.Records &&
              data.Records.length > 0
            ) {
              this.FlatMerchandiseTransactions = data.Records;
              this.MerchandiseTransactions = _.groupBy(data.Records, "mt_id");

              console.log(
                "this.MerchandiseTransactions",
                this.MerchandiseTransactions
              );
            } else {
              this.FlatMerchandiseTransactions = [];
              this.MerchandiseTransactions = [];
              // this.$toasted.show(this.$t("No Records Found"));
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          })
          .finally(() => {
            // setTimeout(() => loader.hide(), 1000);
          });
      }
    },
    getCinemaList: function (cine_id) {
      this.Cinemas = [];
      //  let payload = null
      //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            // this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // let cinema = {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // };

                // this.onSelectCinema(null,cinema);
                // this.onDailyReportFlagHandler({
                // event: null,
                // name: "isCinema",
                // value: x.cine_id,
                // cine_name: x.cine_name
                // });
                this.onDailyReportDropdownHandler({
                  name: "Cinema",
                  selectedItem: { cine_name: x.cine_name, cine_id: x.cine_id },
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    //     getDailyReportV2() {
    // ReportsServiceV2.GetDailyReportList().then((result)=>{

    // })
    //     },
    ...mapActions([
      // FETCH FROM MASTER STORE
      "fetchCinemasList",
      "fetchPosUsersList",
      "fetchPaymentTypesList",

      // FETCH LIST ONLY
      "fetchDailyReportListv2",
      "onDailyReportDateHandler",
      "onDailyReportDropdownHandler",
      "onDailyReportFlagHandler",
      "onFetchDailyConcessionReport",
      // ON RESET ALL
      "onResetDailyReportStoreState",
    ]),
  },
  beforeDestroy: async function () {
    console.log("getDailyExcelFileName :", this.getDailyExcelFileName);
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getDailyExcelFileName,
    });
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getDailyPDFFileName,
    });
    await this.onResetDailyReportStoreState();
  },
};
</script>

<style>
/* .align-last-center tr>th:last-child, tr>td:last-child {
  text-align: center;
}

.align-first-left tr > th:first-child,
tr > td:first-child {
  text-align: left;
  padding-left: 2px;
}

.align-last-right tr > th:last-child,
tr > td:last-child {
  text-align: right;
  padding-right: 2px;
} */

.fixed-layout-table {
  width: 100%;
  table-layout: fixed;
  white-space: normal;
}

.table-elements-border > thead > tr > th:not(:last-child),
.table-elements-border > tbody > tr > td:not(:last-child) {
  border-right: 1px solid black;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/dailySalesReoprt_OLD_res-v2.vue